


























































































































import { defineComponent, computed } from "@nuxtjs/composition-api";
import { storeToRefs } from "pinia";
import { usePartFinderStore } from "~/modules/part-finder/stores/partFinder";
import DropdownBox from "./DropdownBox.vue";
import { watch, ref } from "@nuxtjs/composition-api";
import { SfCheckbox, SfButton } from "@storefront-ui/vue";
import SkeletonLoader from "components/theme/SkeletonLoader.vue";

interface DropdownOption {
  value: number;
  label: string;
}

export default defineComponent({
  name: "PartsTree",
  components: {
    DropdownBox,
    SfCheckbox,
    SfButton,
    SkeletonLoader,
  },
  emits: ["selectFilter", "removeFilter"],
  setup(props, { emit }) {
    const store = usePartFinderStore();

    const {
      finders,
      brands,
      models,
      findersLoading,
      brandsLoading,
      modelsLoading,
      selectedFinder,
      selectedBrand,
      selectedModel,
    } = storeToRefs(store);
    const { setBrand, setModel, setFinder, reset } = store;

    const finderOptions = computed(() =>
      finders.value
        .map((finder) => {
          return {
            label: finder.name,
            value: finder.finder_id,
          };
        })
        .sort((a, b) => a.value - b.value)
    );

    watch(
      finderOptions,
      (options) => {
        if (selectedFinder.value) return;
        const finder = finders.value.find((finder) => finder.finder_id === 1);
        if (finder) setFinder(finder);
      },
      { immediate: true }
    );

    const brandOptions = computed(() =>
      brands.value.map((brand) => {
        return {
          label: brand.name,
          value: brand.brand_id,
        };
      })
    );

    const modelOptions = computed(() =>
      models.value.map((model) => {
        return {
          label: model.name,
          value: model.model_id,
        };
      })
    );

    function selectFinder(option: DropdownOption) {
      if (
        selectedFinder.value &&
        selectedFinder.value.finder_id === option.value
      ) {
        selectedFinder.value = null;
        brandsSearchTerm.value = "";

        return;
      }

      const chosenFinder = finders.value.find(
        (f) => f.finder_id === option.value
      );
      if (chosenFinder) {
        setFinder(chosenFinder);
      }
    }

    function applyModelFilter(option: DropdownOption) {
      if (
        selectedModel.value &&
        selectedModel.value.model_id === option.value
      ) {
        emit("removeFilter", {
          brand: selectedBrand.value.slug,
          model: selectedModel.value.slug,
        });
        selectedModel.value = null;

        return;
      }

      selectModel(option);

      if (selectedModel.value !== null) {
        emit("selectFilter", {
          brand: selectedBrand.value.slug,
          model: selectedModel.value.slug,
          finder: selectedFinder.value.slug,
        });
      }
    }
    function selectBrand(option: DropdownOption) {
      if (
        selectedBrand.value &&
        selectedBrand.value.brand_id === option.value
      ) {
        selectedBrand.value = null;
        modelsSearchTerm.value = "";
        return;
      }
      const chosenBrand = brands.value.find((b) => b.brand_id === option.value);
      if (chosenBrand) {
        setBrand(chosenBrand);
      }
    }

    function selectModel(option: DropdownOption) {
      const chosenModel = models.value.find((m) => m.model_id === option.value);
      if (chosenModel) {
        setModel(chosenModel);
      }
    }

    const brandsSearchTerm = ref<string>("");
    const modelsSearchTerm = ref<string>("");

    const filteredBrandOptions = computed(() => {
      if (!brandOptions.value?.length) {
        return brandOptions.value;
      }
      const searchTerm = brandsSearchTerm.value.toLowerCase();
      return brandOptions.value.filter((brand: DropdownOption) =>
        brand.label.toLowerCase().startsWith(searchTerm)
      );
    });
    const filteredModelOptions = computed(() => {
      if (!modelOptions.value?.length) {
        return modelOptions.value;
      }
      const searchTerm = modelsSearchTerm.value.toLowerCase();
      return modelOptions.value.filter((model: DropdownOption) =>
        model.label.toLowerCase().startsWith(searchTerm)
      );
    });

    return {
      selectedFinder,
      selectedBrand,
      selectedModel,
      brandsLoading,
      modelsLoading,
      findersLoading,
      brandOptions,
      modelOptions,
      finderOptions,
      selectBrand,
      selectModel,
      selectFinder,
      applyModelFilter,
      brandsSearchTerm,
      modelsSearchTerm,
      filteredBrandOptions,
      filteredModelOptions,
    };
  },
});
